module.exports = __webpack_public_path__ + "img/sprite.bad4ca73.svg";